import React from 'react'
import { Link } from 'gatsby'
import starIcon from '../../assets/images/star-icon.png'
import shape from '../../assets/images/shape/shape1.svg'
import client1 from '../../assets/images/testimonials/client1.jpg'
import client2 from '../../assets/images/testimonials/client2.jpg'
import client3 from '../../assets/images/testimonials/client3.jpg'
import Loadable from '@loadable/component'

const OwlCarousel = Loadable(() => import('react-owl-carousel3'))

const options = {
    loop: false,
    nav: true,
    autoplayHoverPause: true,
    autoplay: false,
    items: 1,
    dots: true,
    margin: 30,
    navText: [
        "<i class='flaticon-left-1'></i>",
        "<i class='flaticon-right-1'></i>",
    ],
}

const slides = [
    {
        quote: `Panacea enabled us to move from the cumbersome and error prone manual system to the automated paperless electronic system, enabling us to deliver safer blood, without compromising on throughput. We have been able to implement international blood banking standards at our facilities, providing quality health care to our patients.
We opted for Zaavia's "Panacea with Cloud" subscription package specially to relieve our IT infrastructure of any further added load. The cloud server service has been reliable, with literally negligible downtimes.
Panacea now operates behind the scenes, as an integral part of our own services.`,
        image: client1,
        name: 'Dr Arif Hussain',
        designation: 'Director at Clinical Laboratories and Blood Bank',
    },
    {
        quote: `The Indus Hospital Blood Centre was the first centralised blood centre established in Pakistan, in 2013. The Blood Banking Management Information System, Panacea, was provided by Zaavia. Since its deployment, blood donations through drives have grown over 30% annually, enabling us to increase the number of partner hospitals. Panacea enables us to host completely paperless blood drives spanning over 3527 square kilometers of Karachi, covering a population of 20 million.
We have now deployed Panacea in 1 regional blood centre in Karachi, and 3 hospital blood banks in rural areas of Pakistan. Given the remote location of the hospital blood banks, our fears of monitoring quality, in a human resource compromised environment, have been allayed by the error trapping and reporting functionality of Panacea.
Our experience with Panacea and the Zaavia team, has resulted in our decision to deploy Panacea at all our new centres stretching across Sindh and Punjab.`,
        image: client2,
        name: 'Prof. Abdul Bari Khan',
        designation: 'CEO at The Indus Hospital Karachi, Pakistan',
    },
    {
        quote: `National Institute of Blood Disease and Bone Marrow Transplantation is a specialised centre of Haematology, Bone Marrow Transplantation and Allied Surgical/Medical Specialties. With our state of the art services, we required a commensurate Blood Banking Management Information System (BBMIS), ensuring the quality of the blood transfusion services. The inventory status screen on its own convinced us that this is exactly what we needed. With all the important blood unit information on one screen, further layered with details at a touch, indicated that Panacea has been designed and developed by haematologists who understood the practical issues in blood banks today.
The deployment of Panacea was performed seamlessly, as was the training. The online 24/7 Zaavia support has kept our services up and running, minimizing down time, without the need for onsite visits. Panacea has complemented the performance of our human resource, and further elevated the quality of our transfusion services.`,
        image: client3,
        name: 'Prof. Tahir S. Shamsi',
        designation: 'MBBS, FCPP, MRCPath, FRCPath. Professor of Haematology, Consultant Haematologist & Transplant Physician',
    },
]

const HomeTestimonials = () => {
    const [display, setDisplay] = React.useState(false)

    React.useEffect(() => {
        setDisplay(true)
    }, [])

    return (
        <div className="testimonials-area home-testimonials-area pt-70 pb-70 bg-f1f8fb component-parent">
            <div className="container">
                <div className="section-title">
                    <span className="sub-title">
                        <img src={starIcon} alt="testimonial" />
                        Testimonials
                    </span>
                    <h2>What Our Clients are Saying?</h2>
                </div>

                {display ? (
                    <OwlCarousel
                        className="testimonials-slides owl-carousel owl-theme"
                        {...options}
                    >
                        {slides.map((slide) => (
                            <div className="single-testimonials-item" key={slide.name}>
                                <p className="text-center">{slide.quote}</p>
                                <div className="client-info">
                                    <div className="d-flex justify-content-center align-items-center">
                                        <img src={slide.image} alt={slide.name} />
                                        <div className="title">
                                            <p className="client-name">{slide.name}</p>
                                            <span>{slide.designation}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </OwlCarousel>
                ) : (
                    ''
                )}

                <div className="testimonials-view-btn text-center">
                    <Link to="/testimonials" className="default-btn">
                        <i className="flaticon-view"></i>
                        Read More
                        <span></span>
                    </Link>
                </div>
            </div>

            <div className="shape-img1">
                <img src={shape} alt="testimonial" />
            </div>
        </div>
    )
}

export default HomeTestimonials
